import { Component, Input } from '@angular/core';
import { ApplicantForm } from '../../forms/applicant.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-applicant-address-data-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective, ValidationErrorsComponent],
  templateUrl: './applicant-address-data-form.component.html'
})
export class ApplicantAddressDataFormComponent {
  @Input()
  public form: ApplicantForm | undefined;
}
